module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "chap1"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "chap1"
    }
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EONA ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFFERSON DID HER")]), _vm._v(" job, always. She was the Sensitive. Now she murmured incantations and placed spells in the long grass and snakebeds of the Quinella Trace lands. She followed the bank of the Quinella River to a great shade tree that grew thick with dark as the sun set.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We waited for you,” came the dreamy voice of Justice Douglass from under the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The voice vibrated as the Sensitive knelt under branches. There were the four children of power seated around the shade buckeye. They had joined hands and were now the unit, ready to leave for the future.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Wait!” cried the Sensitive, trying to hold them back.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Power filled the eyes of the four. i am leaving, the unit conveyed. i will be back.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Sensitive sensed a calm farewell and a feeling of adventure as the unit went on its way.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("i am the Watcher. The sounding rhythm of the unit vibrated.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("An amazing light spread from the four. It tangled in piercing rays from the evening sun. Then the children were gone. However, their physical selves remained, hands joined around the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Sensitive waited out the lonely night. Softly she crooned to the empty-headed ones. She slept finally, sitting up. But her seer’s insight stayed wide awake. Leona Jefferson missed nothing that was going on.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7076db82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5start.vue
// module id = 66
// module chunks = 0